import type { ProductOffer } from '@/api/backend/contract/ProductList';

export function getInitialProductOffer(
  productOffers: ProductOffer[] | undefined,
  showSizeSelector?: boolean,
  preferredSize?: string | null
): ProductOffer | null {
  if (!productOffers?.length) return null;

  const hasSizeSelector =
    showSizeSelector ?? !(productOffers.length === 1 && !productOffers[0].size);

  if (!hasSizeSelector) {
    return productOffers.length === 1 ? productOffers[0] : null;
  }

  if (preferredSize) {
    const remembered = productOffers.find(
      (offer) => offer.size === preferredSize && offer.totalStock > 0
    );
    if (remembered) return remembered;
  }

  return productOffers.find((offer) => offer.totalStock > 0) ?? productOffers[0];
}
